import script from "./EditUserProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditUserProfile.vue?vue&type=script&setup=true&lang=ts"

import "./EditUserProfile.vue?vue&type=style&index=0&id=0a12793c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a12793c"]])

export default __exports__